export default __webpack_public_path__ + "static/media/candidate_active.a3b2a9b5.svg";